export default __webpack_public_path__ + "static/Hotel-3a0499f34630d01d3de213ddf2d76eb5.png";